import cake1 from "../assets/images/Cakes/cake1.webp";
import cake2 from "../assets/images/Cakes/cake2.webp";
import strawberryBliss from "../assets/images/Cakes/StrawberryBliss.webp";
import cake4 from "../assets/images/Cakes/cake4.webp";



const featuredCakes = [
  {
    id: 1,
    name: "Chocolate Delight",
    category: "Chocolate",
    price: 1999,
    image: cake1,
    description:
      "Rich and moist chocolate cake layered with smooth chocolate ganache.",
    ingredients: [
      "Fresh cream",
      "Butter",
      "Eggs",
      "Sugar",
    ],
  },
  {
    id: 2,
    name: "Classic Cream Cake",
    category: "Classic",
    price: 1499,
    image: cake2,
    description:
      "A timeless vanilla sponge cake topped with fresh cream and floral decor.",
    ingredients: [
      "Vanilla essence",
      "Fresh cream",
      "Butter",
      "Eggs",
      "Sugar",
      "Flour",
    ],
  },
  {
    id: 3,
    name: "Strawberry Bliss",
    category: "Fruit",
    price: 1899,
    image: strawberryBliss,
    description:
      "Light vanilla sponge layered with fresh strawberries and whipped cream.",
    ingredients: [
      "Fresh strawberries",
      "Whipped cream",
      "Vanilla sponge",
      "Butter",
      "Sugar",
      "Flour",
    ],
  },
  {
    id: 4,
    name: "Caramel Crunch",
    category: "Caramel",
    price: 1800,
    image: cake4,
    description:
      "Soft caramel sponge topped with salted caramel drizzle and crunchy nuts.",
    ingredients: [
      "Caramel sauce",
      "Salted butter",
      "Roasted nuts",
      "Fresh cream",
      "Eggs",
      "Sugar",
    ],
  },
];

export default featuredCakes;